// extracted by mini-css-extract-plugin
export var box = "Grid-module--box--5e609";
export var box_md = "Grid-module--box_md--afdff";
export var box_xmd = "Grid-module--box_xmd--a8957";
export var box_flex = "Grid-module--box_flex--1d6db";
export var box_lg = "Grid-module--box_lg--e959b";
export var box_sm = "Grid-module--box_sm--7e93b";
export var box_outer = "Grid-module--box_outer--8ee9c";
export var box_whiteBg = "Grid-module--box_white-bg--42719";
export var box_noMarginBottom = "Grid-module--box_no-margin-bottom--ed9f4";
export var box_noPadding = "Grid-module--box_no-padding--c51a5";
export var box_outerGray = "Grid-module--box_outer-gray--df1e1";
export var box_dark = "Grid-module--box_dark--f3b4a";
export var box_zIndex = "Grid-module--box_z-index--47ea2";
export var box_zIndex6 = "Grid-module--box_z-index-6--6f24b";
export var box_eventsWithLine = "Grid-module--box_events-with-line--47438";
export var box_featuresAo = "Grid-module--box_features-ao--46f68";
export var box_verticalPaddings = "Grid-module--box_vertical-paddings--c357b";
export var clearP = "Grid-module--clearP--95600";
export var clearP_vc = "Grid-module--clearP_vc--7bc60";
export var grid = "Grid-module--grid--387ef";
export var fadeInAnimation = "Grid-module--fadeInAnimation--e5978";
export var placeHolderShimmer = "Grid-module--placeHolderShimmer--e5fa1";